<script>
    import R, {LOADER} from "../../lib/requests";
    import {setFocusTo} from "../../lib/lib";
    import Modal from '../../components/modal/Modal.svelte';
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import InputGroupColor from "../../components/controls/InputGroupColor.svelte";
    import PasswordControl from "../../components/controls/PasswordControl.svelte";

    export let userId = null;
    export let closeCallback;

    let user = null;
    let modalTitle = 'Χρήστης';

    const load = () => {

        const onSuccess = result => {
            user = result;
            setFocusTo('name');
        }

        const onFailure = err => {
            Alert.warning("Χρήστης", err.message);
        };

        R.handle(R.user.details, userId, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {

        const onSuccess = result => {
            close(result);
            Notifier.showMessage("Ο λογαριασμός του χρήστη ενημερώθηκε");
        }

        const onFailure = err => {
            let fields = {
                name: 'Όνομα',
                email: 'Email',
                password: 'Κωδικός',
                new_password: 'Νέος κωδικός',
            }
            let prompt = '';
            let focusTo = err.params && err.params.field ? err.params.field : null;
            if (err.code === 'field_required') {
                prompt = `Το πεδίο "${fields[err.params.field]}" είναι απαιτούμενο!`;
            } else if (err.code === 'field_invalid') {
                prompt = `Το πεδίο "${fields[err.params.field]}" δεν είναι έγκυρο!`;
            }

            if (prompt) {
                Notifier.showError(prompt);
                setFocusTo(focusTo);
            } else {
                Alert.warning("Χρήστης", err.message);
            }
        };

        if (!user.name.trim()) {
            Notifier.showError("Πληκτρολογήστε ένα όνομα για τον χρήστη!");
            setFocusTo('name');
            return;
        }

        if (user.new_password && !user.new_password.trim()) {
            delete(user.new_password);
        }

        let action = user.id === 0 ? 'create' : 'edit';
        R.handle(R.user[action], user, onSuccess, onFailure, LOADER.POPUP);
    }


    const initialize = () => {
        if (!userId) {
            user = {
                id: 0,
                name: '',
                email: '',
                password: '',
            };

            modalTitle = 'Νέος χρήστης';
            setFocusTo('name');
        } else {
            load();
        }
    }

    const close = (param) => {
        user = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if user}
    <Modal title="{ modalTitle }" icon="client" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <h6 class="mb-2">Όνομα</h6>
                <div class="input-group">
                    <input type="text" class="form-control" id="name" bind:value="{ user.name }"
                           required>
                    <InputGroupColor bind:value="{ user.color }"/>
                </div>
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="email" bind:value="{ user.email }">
            </div>
            {#if user.id == 0}
                <div class="form-group">
                    <label>Κωδικός</label>
                    <PasswordControl id="password" bind:value="{ user.password }" required/>
                </div>
            {:else}
                <div class="form-group">
                    <label>Νέος κωδικός</label>
                    <PasswordControl id="new_password" bind:value="{ user.new_password }" required/>
                </div>
            {/if}
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
            </div>
        </div>
    </Modal>
{/if}